(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atd-categories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof EmblaCarousel === 'undefined') return;
    
    const section = document.getElementById('atd-categories');
    if (!section) return;

    const emblaNode = section.querySelector('.embla');
    const buttonsContainer = section.querySelector('.scroll-buttons');
    const prevButtonNode = section.querySelector('.prev');
    const nextButtonNode = section.querySelector('.next');

    const options = { align: 'start' };
    const emblaApi = EmblaCarousel(emblaNode, options);

    const toggleButtons = () => {
      prevButtonNode.disabled = !emblaApi.canScrollPrev();
      nextButtonNode.disabled = !emblaApi.canScrollNext();

      if (!emblaApi.canScrollPrev() && !emblaApi.canScrollNext()) {
        buttonsContainer.style.display = 'none';
      } else {
        buttonsContainer.removeAttribute('style');
      }
    };

    prevButtonNode.addEventListener('click', () => emblaApi.scrollPrev());
    nextButtonNode.addEventListener('click', () => emblaApi.scrollNext());

    emblaApi.on('init', toggleButtons).on('select', toggleButtons).on('reInit', toggleButtons);

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atd-featured-products-og"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof EmblaCarousel === 'undefined') return;

    const section = document.querySelector('.atd-featured-products');
    if (!section) return;

    const emblaNode = section.querySelector('.embla');
    const buttonsContainer = section.querySelector('.scroll-buttons');
    const prevButtonNode = section.querySelector('.prev');
    const nextButtonNode = section.querySelector('.next');

    const options = { align: 'start' };
    const emblaApi = EmblaCarousel(emblaNode, options);

    const toggleButtons = () => {
      prevButtonNode.disabled = !emblaApi.canScrollPrev();
      nextButtonNode.disabled = !emblaApi.canScrollNext();

      if (!emblaApi.canScrollPrev() && !emblaApi.canScrollNext()) {
        buttonsContainer.style.display = 'none';
      } else {
        buttonsContainer.removeAttribute('style');
      }
    };

    prevButtonNode.addEventListener('click', () => emblaApi.scrollPrev());
    nextButtonNode.addEventListener('click', () => emblaApi.scrollNext());

    emblaApi.on('init', toggleButtons).on('select', toggleButtons).on('reInit', toggleButtons);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atd-featured-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    console.log("Loaded")
    if (typeof EmblaCarousel === 'undefined') return;
    console.log("EMbla Loaded")

    const section = document.querySelector('.atd-featured-products');
    if (!section) return;

    const emblaNode = section.querySelector('.embla');
    const buttonsContainer = section.querySelector('.scroll-buttons');
    const prevButtonNode = section.querySelector('.prev');
    const nextButtonNode = section.querySelector('.next');

    const options = { align: 'start' };
    const emblaApi = EmblaCarousel(emblaNode, options);

    const toggleButtons = () => {
      prevButtonNode.disabled = !emblaApi.canScrollPrev();
      nextButtonNode.disabled = !emblaApi.canScrollNext();

      if (!emblaApi.canScrollPrev() && !emblaApi.canScrollNext()) {
        buttonsContainer.style.display = 'none';
      } else {
        buttonsContainer.removeAttribute('style');
      }
    };

    prevButtonNode.addEventListener('click', () => emblaApi.scrollPrev());
    nextButtonNode.addEventListener('click', () => emblaApi.scrollNext());

    emblaApi.on('init', toggleButtons).on('select', toggleButtons).on('reInit', toggleButtons);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atd-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.atd-header-wrapper');
      this.setHeaderHeight();
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      window.addEventListener('resize', this.setHeaderHeight.bind(this));
      window.addEventListener('scroll', this.onScroll.bind(this));
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.setHeaderHeight.bind(this));
      window.removeEventListener('scroll', this.onScroll.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight + 1}px`);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= 0) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden');
    }

    reveal() {
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  if (typeof EmblaCarousel === 'undefined') return;

  const section = document.querySelector('.atd-featured-products');
  if (!section) return;

  const recommendationsEl = section.querySelector('product-recommendations');
  if (!recommendationsEl) return;

  const initEmbla = () => {
    const emblaNode = section.querySelector('.embla');
    if (!emblaNode) return;

    const buttonsContainer = section.querySelector('.scroll-buttons');
    const prevButtonNode = section.querySelector('.prev');
    const nextButtonNode = section.querySelector('.next');

    if (!prevButtonNode || !nextButtonNode) return;

    const emblaApi = EmblaCarousel(emblaNode, { align: 'start' });

    const toggleButtons = () => {
      const canPrev = emblaApi.canScrollPrev();
      const canNext = emblaApi.canScrollNext();

      prevButtonNode.disabled = !canPrev;
      nextButtonNode.disabled = !canNext;

      if (!canPrev && !canNext) {
        buttonsContainer.style.display = 'none';
      } else {
        buttonsContainer.removeAttribute('style');
      }
    };

    prevButtonNode.addEventListener('click', () => emblaApi.scrollPrev());
    nextButtonNode.addEventListener('click', () => emblaApi.scrollNext());

    emblaApi
      .on('init', toggleButtons)
      .on('select', toggleButtons)
      .on('reInit', toggleButtons);

    toggleButtons();
  };

  // If recommendations already rendered (cached / fast load)
  if (recommendationsEl.querySelector('.embla')) {
    initEmbla();
    return;
  }

  // Observe async injection by Shopify
  const observer = new MutationObserver(() => {
    if (recommendationsEl.querySelector('.embla')) {
      observer.disconnect();
      initEmbla();
    }
  });

  observer.observe(recommendationsEl, {
    childList: true,
    subtree: true
  });
});

  } catch(e) { console.error(e); }
})();
})();
